import { useState } from "react";
import { repositoryMdm } from "../../_base/_const/_constVar";
import { MessageResponse } from "../../model/MessageResponse";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import {
  Badge,
  Box,
  Button,
  Divider,
  Flex,
  NumberInput,
  Textarea,
  TextInput,
} from "@mantine/core";
import { IconCheck, IconX } from "@tabler/icons-react";

interface updatePoint {
  code: string;
  type: number;
  modifiedPoint: number;
  note: string;
}

const UpdatePointKTKT = ({
  code,
  type,
  setSelectMenu,
  fetchData,
  point,
  modifiedPoint,
}: {
  code: string;
  type: number;
  setSelectMenu: any;
  fetchData: any;
  point: number | null;
  modifiedPoint: number;
}) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [dataSubmit, setDataSubmit] = useState<updatePoint>({
    code: code,
    type: type,
    modifiedPoint: modifiedPoint,
    note: "",
  });

  const handleSubmit = async () => {
    setIsLoading(true);
    const res = await repositoryMdm.post<MessageResponse<updatePoint>>(
      "/api/v1/VReportDelivery/update-point-for-manager",
      dataSubmit,
    );

    if (res && res.success) {
      NotificationExtension.Success("Chỉnh sửa thành công !");
      setTimeout(() => {
        setIsLoading(false);
        fetchData();
        setSelectMenu(-1);
      }, 1000);
    } else {
      NotificationExtension.Fails(res?.message);
      setIsLoading(false);
    }
  };

  return (
    <Box
      w={"100%"}
      p={10}
      style={{ border: "1px solid orange", borderRadius: "2.5px" }}
    >
      <Flex
        justify={"center"}
        align={"center"}
        w={"100%"}
        direction={"column"}
        gap={"5px"}
      >
        <Badge color={"green"} radius="sm" variant="dot" size="lg">
          {dataSubmit.code}
        </Badge>
        <Divider label="Cập nhật điểm KTKT" labelPosition="center" w={455} />
        <Flex w={455} gap={"md"}>
          <TextInput
            label="Điểm hiện tại"
            placeholder="Điểm hiện tại"
            value={point ? point : 0}
            w={"100%"}
            readOnly
          />
          <NumberInput
            label="Điểm sửa"
            placeholder="Nhập điểm sửa"
            hideControls
            value={dataSubmit.modifiedPoint}
            allowNegative={true}
            max={60}
            min={-60}
            w={"100%"}
            onChange={(e) =>
              setDataSubmit((prev) => ({
                ...prev,
                modifiedPoint: Number(e),
              }))
            }
            error={
              Number(dataSubmit.modifiedPoint) > 60
                ? "Điểm sửa không được vượt quá 60"
                : Number(dataSubmit.modifiedPoint) < -60
                  ? "Điểm sửa không được nhỏ hơn -60"
                  : false
            }
          />
        </Flex>
        <Textarea
          label="Ghi chú"
          placeholder="Nhập ghi chú"
          value={dataSubmit.note}
          onChange={(e) =>
            setDataSubmit((prev) => ({ ...prev, note: e.target.value }))
          }
          w={455}
        />
        <Flex justify={"center"} align={"center"} gap={"md"}>
          <Button
            variant="filled"
            color="teal"
            leftSection={<IconCheck size={14} />}
            onClick={() => handleSubmit()}
            disabled={
              isLoading ||
              Number(dataSubmit.modifiedPoint) > 60 ||
              Number(dataSubmit.modifiedPoint) < -60
            }
            loading={isLoading}
            size="xs"
          >
            Xác nhận
          </Button>
          <Button
            variant="filled"
            color="red"
            leftSection={<IconX size={14} />}
            onClick={() => {
              if (setSelectMenu) {
                setSelectMenu(-1);
              }
            }}
            size="xs"
          >
            Đóng
          </Button>
        </Flex>
      </Flex>
    </Box>
  );
};

export default UpdatePointKTKT;
